interface ActionCableConfig {
  url: string;
}

const getActionCableConfig = (): ActionCableConfig => {
  const appEnv = process.env.NEXT_PUBLIC_NODE_ENV;

  // Allow override via environment variable
  if (process.env.NEXT_PUBLIC_ACTION_CABLE_URL) {
    return { url: process.env.NEXT_PUBLIC_ACTION_CABLE_URL };
  }

  // Derive WebSocket URL from API URL if set
  if (process.env.NEXT_PUBLIC_API_URL) {
    const apiUrl = process.env.NEXT_PUBLIC_API_URL;
    const wsUrl =
      apiUrl
        .replace(/^https:/, 'wss:')
        .replace(/^http:/, 'ws:')
        .replace(/\/$/, '') + '/cable';
    return { url: wsUrl };
  }

  if (appEnv === 'staging') {
    return { url: 'wss://api.lingualbox.jp/cable' };
  } else if (appEnv === 'prod') {
    return { url: 'wss://api.lingualbox.com/cable' };
  }

  // Development - use ws:// for local (port 8080 via foreman)
  // Note: When using ngrok (HTTPS), set NEXT_PUBLIC_API_URL to enable WebSocket
  return { url: 'ws://api.lingualbox.loc:8080/cable' };
};

export default getActionCableConfig;
